import { SBOM_PORTAL } from '../../../../shared/featureFlags/flagNames';
import { Action, ResourceType } from '../../../../typings/permissions';
import { useParams, useQuery } from '../../../contexts/RouterContext';
import { useIsFeatureEnabled } from '../../../helpers/features/featureFlags';
import useHasPermission from '../../../shared/permissions/useHasPermission';
import { isReleaseGroupScope, type ReportsV3Params, type ReportsV3QueryParams } from '../types';

import { useReportType } from './useReportType';

/**
 * Whether the current user can publish the current Licensing report to the SBOM
 * portal.
 *
 * Publishing a Licensing report is only available for the Plain Text (TXT)
 * format at the release group level. Like SBOM publishing, it requires both the
 * `SBOM_PORTAL` feature flag and the "manage organization portal reports"
 * permission.
 */
export function useCanPublishLicensingTxt(): boolean {
  const reportType = useReportType();
  const params = useParams<ReportsV3Params>();
  const [query] = useQuery<ReportsV3QueryParams>();
  const isReleaseGroup = isReleaseGroupScope(params);
  const isSbomPortalEnabled = useIsFeatureEnabled(SBOM_PORTAL);
  const hasPermission = useHasPermission();
  const canManagePortalReports = hasPermission({
    resourceType: ResourceType.OrganizationPortalReports,
    action: Action.Manage,
  });

  return (
    reportType === 'licensing' &&
    query.format === 'TXT' &&
    isReleaseGroup &&
    isSbomPortalEnabled &&
    canManagePortalReports
  );
}
